import { render } from "./WhatsNewDetails.vue?vue&type=template&id=72c5fff7&scoped=true&ts=true"
import script from "./WhatsNewDetails.vue?vue&type=script&lang=ts"
export * from "./WhatsNewDetails.vue?vue&type=script&lang=ts"

import "./WhatsNewDetails.vue?vue&type=style&index=0&id=72c5fff7&lang=scss"
import "./WhatsNewDetails.vue?vue&type=style&index=1&id=72c5fff7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c5fff7"]])

export default __exports__